module.exports = __webpack_public_path__ + "static/the-everything-store-jeff-bezos-and-the-age-of-amazon-6a530619b1435411cf1d9087acadaed3.jpg";